import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import i18n from '@/i18n';
import ApiService from '@/services/ApiService';
import Device from '@/wrappers/Device';

const LOCALE_KEY = 'locale';
const LANGUAGE_KEY = 'language';
const CURRENCY_KEY = 'currency';

const Locale = {

    /**
     * Get Locale
     */
    getLocale() {
        return AppStorage.local().getItem(LOCALE_KEY, null);
    },

    /**
     * Set Locale
     */
    async setLocale(locale = null) {
        if(!locale) {
            locale = await this.detectLocale()
        }

        const device = Device.get()
        const isMobile = device?.platform === 'android' || device?.platform === 'ios';
        if(locale && isMobile) {
            const apiUrlEnv = `VUE_APP_${isAllegra ? 'ALLEGRA' : 'ARIA'}_API_URL_${locale.toUpperCase()}`
            if(process.env[apiUrlEnv]) {
                ApiService.setBaseUrl(process.env[apiUrlEnv])
            } else {
                ApiService.resetBaseUrl()
            }
        }

        Object.defineProperty(Vue.prototype, 'locale', { value: locale, configurable: true });
        window.locale = locale

        AppStorage.local().setItem(LOCALE_KEY, locale, null);
    },

    /**
     * Get Language
     */
    getLanguage() {
        return AppStorage.local().getItem(LANGUAGE_KEY, null);
    },

    /**
     * Set Language
     */
    setLanguage(language = null) {
        if(!language) {
            language = this.getLanguage()
        }

        if(!language) {
            language = this.getLocale()
        }

        i18n.locale = language;

        if (language === 'sr' || language === 'me' || language === 'ba') {
            vuetify.framework.lang.current = 'srLat';
        } else {
            vuetify.framework.lang.current = language;
        }

        AppStorage.local().setItem(LANGUAGE_KEY, language, null);
    },

    /**
     * Get Currency
     */
    getCurrency() {
        return AppStorage.local().getItem(CURRENCY_KEY, null);
    },

    /**
     * Set Currency
     */
    setCurrency(currency = null) {
        if(!currency) {
            currency = this.getCurrency()
        }

        if(!currency) return

        Money.currency = currency;
        AppStorage.local().setItem(CURRENCY_KEY, currency, null);
    },

    /**
     * Try to detect Locale
     */
    async detectLocale() {
        let locale = this.getLocale()

        if(!locale) {
            locale = process.env.VUE_APP_I18N_LOCALE
        }

        return locale
    }
};

export default Locale;

export { Locale };
